import React from "react";
import { connect } from 'react-redux';
import { Card, CardBody, CardHeader, Row, Col, Badge } from "reactstrap";
import reduxHelper from "./../../../helper/index.js";
import BadgeCard from './BadgeCard.jsx';

class BadgeSummaryWidget extends React.Component {

  constructor(props) {
    super(props);
    this.state = { loading: true };
    this.helper = new reduxHelper(this.props);
  }

  async componentDidMount() {
    if (this.props.userId) {
      await Promise.all([
        this.helper.badge().getBadgesByUser(this.props.userId),
        this.helper.badge().getBadgeCount(this.props.userId),
        this.helper.badge().getCertificateCount(this.props.userId)
      ]);
    }
    this.setState({ loading: false });
  }

  render() {

    var badges = this.props.badge.badges || [];
    var badgeCount = this.props.badge.badgeCount || 0;
    var certCount = this.props.badge.certificateCount || 0;
    var translate = this.props.translate || {};
    var recentBadges = badges.slice(0, 6);

    if (this.state.loading) {
      return (
        <Card className="shadow">
          <CardBody className="text-center py-3">
            <i className="fas fa-spinner fa-spin text-muted" />
          </CardBody>
        </Card>
      );
    }

    return (
      <Card className="shadow">
        <CardHeader className="d-flex justify-content-between align-items-center py-2">
          <h5 className="mb-0" style={{ fontSize: '0.9rem' }}>
            <i className="fas fa-award mr-2" style={{ color: '#FFD700' }} />
            {translate['minhas_conquistas'] || 'Minhas Conquistas'}
          </h5>
          <div>
            <Badge color="warning" pill className="mr-1">
              <i className="fas fa-award mr-1" />{badgeCount}
            </Badge>
            <Badge color="danger" pill>
              <i className="fas fa-graduation-cap mr-1" />{certCount}
            </Badge>
          </div>
        </CardHeader>
        <CardBody className="py-2">
          {recentBadges.length === 0 ? (
            <div className="text-center py-2">
              <i className="fas fa-award fa-2x text-muted mb-2" style={{ opacity: 0.2 }} />
              <p className="text-muted mb-0" style={{ fontSize: '0.8rem' }}>
                {translate['continue_estudando'] || 'Continue estudando para conquistar badges!'}
              </p>
            </div>
          ) : (
            <Row className="no-gutters">
              {recentBadges.map((badge) => (
                <Col key={badge.id} xs="4" sm="2" className="px-1 mb-1">
                  <BadgeCard badge={badge} size="sm" />
                </Col>
              ))}
            </Row>
          )}
        </CardBody>
      </Card>
    );

  }

}

export default connect(state => ({
  badge: state.badge,
  translate: state.translate,
  user: state.user
}))(BadgeSummaryWidget);
